import React, { createContext, useState, useContext, useCallback, useEffect, useMemo, } from 'react';
import { useDynamicFinancing } from '../../../hooks';
const FinanceContext = createContext(undefined);
export const FinanceProvider = ({ children, vehicle }) => {
    var _a, _b;
    const [selectedModalityInContext, setModalityInContext] = useState(undefined);
    const dynamicFinancingValues = ((_a = vehicle === null || vehicle === void 0 ? void 0 : vehicle.basic) === null || _a === void 0 ? void 0 : _a.financing)
        ? useDynamicFinancing({ vehicle })
        : { rate: '', rateText: '', calculationDisclaimer: '' };
    const [dynamicFinance, setDynamicFinance] = useState(dynamicFinancingValues);
    const updateDynamicFinance = useCallback((values) => {
        var _a;
        if (((_a = vehicle === null || vehicle === void 0 ? void 0 : vehicle.basic) === null || _a === void 0 ? void 0 : _a.financing) && values) {
            setDynamicFinance(Object.assign({}, values));
        }
    }, [(_b = vehicle === null || vehicle === void 0 ? void 0 : vehicle.basic) === null || _b === void 0 ? void 0 : _b.financing]);
    const contextValue = useMemo(() => ({
        selectedModalityInContext,
        setModalityInContext,
        dynamicFinance,
        updateDynamicFinance,
    }), [selectedModalityInContext, dynamicFinance, updateDynamicFinance]);
    useEffect(() => {
        if (!(dynamicFinance === null || dynamicFinance === void 0 ? void 0 : dynamicFinance.rate) && (dynamicFinancingValues === null || dynamicFinancingValues === void 0 ? void 0 : dynamicFinancingValues.rate)) {
            setDynamicFinance(dynamicFinancingValues);
        }
    }, [dynamicFinancingValues === null || dynamicFinancingValues === void 0 ? void 0 : dynamicFinancingValues.rate]);
    if (!(vehicle === null || vehicle === void 0 ? void 0 : vehicle.basic)) {
        return React.createElement(React.Fragment, null, children);
    }
    return React.createElement(FinanceContext.Provider, { value: contextValue }, children);
};
export function useFinance() {
    const context = useContext(FinanceContext);
    if (context === undefined) {
        throw new Error('useFinance must be used within a FinanceProvider');
    }
    return context;
}
